import { defineComponent as _defineComponent } from 'vue';
import { ComboboxRoot } from 'reka-ui';
import ComboboxAnchorPrimitive from './ComboboxAnchor.vue';
import ComboboxInputPrimitive from './ComboboxInput.vue';
import ComboboxContentPrimitive from './ComboboxContent.vue';
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'Combobox',
    props: {
        disabled: { type: Boolean, required: false },
        readonly: { type: Boolean, required: false },
        hasError: { type: Boolean, required: false },
        id: { type: String, required: false },
        displayValue: { type: Function, required: false },
        placeholder: { type: String, required: false }
    },
    emits: ["input"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const emit = __emit;
        const __returned__ = { emit, get ComboboxRoot() { return ComboboxRoot; }, ComboboxAnchorPrimitive, ComboboxInputPrimitive, ComboboxContentPrimitive };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
